import { render, staticRenderFns } from "./ProIncomeData.vue?vue&type=template&id=a94fce86&scoped=true"
import script from "./ProIncomeData.vue?vue&type=script&lang=js"
export * from "./ProIncomeData.vue?vue&type=script&lang=js"
import style0 from "./ProIncomeData.vue?vue&type=style&index=0&id=a94fce86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94fce86",
  null
  
)

export default component.exports